import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

export function Spinner({ size = 18, className = "" }: { size?: number; className?: string }) {
	return <Loader2 size={size} className={`animate-spin ${className}`} aria-hidden />;
}

export function LoadingState({ label }: { label?: string }) {
	const { t } = useTranslation();
	return (
		<div className="flex flex-col items-center justify-center gap-3 py-16 text-muted">
			<Spinner size={26} className="text-brand" />
			<span className="text-sm">{label ?? t("common.loading")}</span>
		</div>
	);
}
